const MetroIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8.5" cy="8.5" r="7.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M4.75 12.25V4.75H6.25L8.5 8.3L10.75 4.75H12.25V12.25H10.6V7.85L8.95 10.4H8.05L6.4 7.85V12.25H4.75Z" fill="currentColor" />
        </svg>
    );
};

export default MetroIcon;
